module.exports = __webpack_public_path__ + "img/2.f9171e3.png";